import React from "react";
import LookupAdmin, { ActiveChip } from "../../components/LookupAdmin";

const config = {
  title: "Motivos de Perda (Deals)",
  endpoint: "/lost-reasons",
  labelField: "name",
  fields: [
    { name: "name", label: "Nome", required: true, span: 8 },
    { name: "active", label: "Ativo", type: "boolean", defaultValue: true }
  ],
  columns: [
    { key: "name", label: "Nome" },
    { key: "active", label: "Status", render: (s) => <ActiveChip active={s.active} /> }
  ]
};

const LostReasons = () => <LookupAdmin config={config} />;

export default LostReasons;
